export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/user.47249088.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};